import { Component, Input } from '@angular/core';

@Component({
  selector: 'portfolio-grid',
  templateUrl: './portfolio-grid.component.html',
  styleUrls: ['./portfolio-grid.component.scss']
})

export class PortfolioGridComponent {
  @Input() project: string;
  @Input() imgAlt1: string;
  @Input() imgUrl1: string;
  @Input() imgAlt2: string;
  @Input() imgUrl2: string;
  @Input() title1: string;
  @Input() description1: string;
  @Input() title2: string;
  @Input() description2: string;
  @Input() color1: string;
  @Input() color2: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/portfolio-grid/portfolio-grid.component.ts